import firebase from "firebase";
import { firebaseBackup } from "../../config/firebase/firebase-backup-config";
import { ApiResponse } from "../ApiResponse";
import moment from "moment";

export const getAll = async (
  entityId: string,
  startDate: Date,
  endDate: Date
): Promise<ApiResponse> => {
  try {
    const currentStartDate = firebase.firestore.Timestamp.fromDate(
      moment(startDate).startOf("day").toDate()
    );

    const currentEndDate = firebase.firestore.Timestamp.fromDate(
      moment(endDate).endOf("day").toDate()
    );

    let query = await firebaseBackup
      .collection("Correspondece")
      .doc(entityId)
      .collection("CorrespondenceSection")
      .where("createAt", ">=", currentStartDate)
      .where("createAt", "<=", currentEndDate)
      .orderBy("createAt", "desc");

    var data = (await query.get()).docs.map((item) => item.data());

    return {
      ok: true,
      data: data,
      message: "Recurso obtenido con exito."
    };
  } catch (error) {
    return {
      ok: false,
      data: null,
      message: error
    };
  }
};

export const getResponseTimesParams = async (entityId: string) => {
  const ResponseTimesParamsFormSnap = await firebaseBackup
    .collection(`/Correspondence/`)
    .doc(`${entityId}`)
    .collection(`/ParamResponseTime/`)
    .doc(`${entityId}`)
    .get();

  return ResponseTimesParamsFormSnap.data();
};
